/**
 * The console's copy of the API's privileged-role rules.
 *
 * Two separate features read these, and both had the constant inlined in
 * `UsersPage.jsx`:
 *
 *   * STARSEED-CAPMARKETS-275 — which lifecycle controls to offer at all. The page
 *     had its own narrower set, so it offered controls that were guaranteed to 403.
 *   * STARSEED-CAPMARKETS-283 — whether the create form's password will be used. The
 *     API discards it for a privileged role created by a non-superuser, and the form
 *     went on requiring it and reporting plain success, so the operator handed over a
 *     password that could not work.
 *
 * Pulled out of the page because the failure mode both times was the copy drifting
 * from `core/security.PRIVILEGED_TARGET_ROLES`, and a constant buried in a 900-line
 * component cannot be asserted on without standing up jsdom and a Radix select.
 */

/** Mirrors `core.security.PRIVILEGED_TARGET_ROLES`. */
export const PRIVILEGED_TARGET_ROLES = new Set(["admin", "superuser", "partner"]);

/**
 * Mirrors `_provisioned_without_credential` in `routes/users.py`: true when
 * `POST /users/create` will replace the submitted password with an unusable value and
 * create the row inactive, so the form must not ask for one or claim it was set.
 */
export const credentialIsDiscarded = (role, actorRole) =>
  PRIVILEGED_TARGET_ROLES.has(role) && actorRole !== "superuser";
